import React, { createContext, useContext, useEffect, useState, useCallback } from "react";
import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

const AuthContext = createContext(null);

export function AuthProvider({ children }) {
    const [user, setUser] = useState(null);
    const [loading, setLoading] = useState(true);
    const [token, setToken] = useState(() => localStorage.getItem("token"));

    const fetchMe = useCallback(async () => {
        try {
            const headers = {};
            const t = localStorage.getItem("token");
            if (t) headers.Authorization = `Bearer ${t}`;
            const res = await axios.get(`${API}/auth/me`, {
                headers,
                withCredentials: true,
            });
            setUser(res.data);
        } catch {
            setUser(null);
        } finally {
            setLoading(false);
        }
    }, []);

    useEffect(() => {
        // CRITICAL: If returning from OAuth callback, skip /me check.
        // AuthCallback will exchange the session_id first.
        if (window.location.hash?.includes("session_id=")) {
            setLoading(false);
            return;
        }
        fetchMe();
    }, [fetchMe]);

    const login = async (email, password) => {
        const res = await axios.post(`${API}/auth/login`, { email, password });
        localStorage.setItem("token", res.data.token);
        setToken(res.data.token);
        setUser(res.data.user);
        return res.data.user;
    };

    const register = async (email, password, name, captcha_token, terms_accepted) => {
        const res = await axios.post(`${API}/auth/register`, { email, password, name, captcha_token, terms_accepted });
        localStorage.setItem("token", res.data.token);
        setToken(res.data.token);
        setUser(res.data.user);
        return res.data.user;
    };

    const logout = async () => {
        try { await axios.post(`${API}/auth/logout`, {}, { withCredentials: true }); } catch {}
        localStorage.removeItem("token");
        setToken(null);
        setUser(null);
    };

    const refresh = fetchMe;

    return (
        <AuthContext.Provider value={{ user, loading, token, login, register, logout, refresh, setUser }}>
            {children}
        </AuthContext.Provider>
    );
}

export const useAuth = () => useContext(AuthContext);

// Authenticated axios helper
export function authHeaders() {
    const t = localStorage.getItem("token");
    return t ? { Authorization: `Bearer ${t}` } : {};
}

export function authFetch(method, url, data) {
    return axios({
        method,
        url: `${API}${url}`,
        data,
        headers: authHeaders(),
        withCredentials: true,
    });
}
